import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as MUILink, SxProps } from "@mui/material";
import { commonStyles } from "./commonStyles";

interface LinkTextProps {
  to: string;
  text: string;
  additionalSx?: SxProps;
}

const LinkText: React.FC<LinkTextProps> = ({ to, text, additionalSx }) => {
  return (
    <MUILink
      component={RouterLink}
      to={to}
      sx={{
        color: commonStyles.cpaGold,
        textDecoration: "none",
        fontSize: commonStyles.fontSizes.medium,
        fontWeight: 500,
        "&:hover": {
          textDecoration: "underline",
        },
        ...additionalSx,
      }}
    >
      {text}
    </MUILink>
  );
};

export default LinkText;
